import { Icons } from "assets";
import classNames from "classnames";
import { useEffect, useState } from "react";
import StatsCard from "shared/components/statsCard";
import { GetDashboardStatsService } from "shared/services/dashboard";
import styles from "./styles.module.scss";
import BarGraph from "shared/components/dashboard/barGraph";
import OrganizationCard from "shared/components/dashboard/organizationCard";
import EvaluationCard from "shared/components/dashboard/evaluationCard";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routeConstant";

const DashboardHome = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(true);
  const [stats, setStats] = useState<any>(null);

  const handleGetStats = () => {
    setLoading(true);
    GetDashboardStatsService()
      .then(({ data }) => {
        setStats(data);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetStats();
  }, []);
  return (
    <div className={classNames("flex flex-col gap-5 w-full h-full")}>
      <div className={classNames("flex items-center gap-5 flex-wrap")}>
        <StatsCard
          title1="No. of"
          title2="Organizations"
          value={stats?.organization}
          loading={loading}
          Icon={Icons.Clipboard}
          onClick={() => {
            navigate(routeConstant.organizations.path);
          }}
        />
        <StatsCard
          title1="No. of Requested"
          title2="Evaluations"
          value={stats?.requestsCount}
          loading={loading}
          Icon={Icons.ClipboardWithPencil}
        />
        <StatsCard
          title1="No. of Evaluations"
          title2="Pending Approval" 
          value={stats?.pendingCount}
          loading={loading}
          Icon={Icons.Evaluation}
          onClick={() => {
            navigate(routeConstant.requestedEvaluation.path);
          }}
        />
        <StatsCard
          title1="No. of Total"
          title2="Evaluations"
          value={stats?.evaluationsCount}
          loading={loading}
          Icon={Icons.Bill}
        />
      </div>
      <div
        className={classNames("flex flex-col md:flex-row items-center gap-5")}
      >
        <div
          className={classNames(styles.container, "gap-5 p-5 w-full md:w-4/6")}
        >
          <BarGraph />
        </div>
        <div
          className={classNames(styles.container, "gap-5 p-5 w-full md:w-2/6 ")}
        >
          <OrganizationCard />
        </div>
      </div>
      <div
        className={classNames(
          styles.container,
          "gap-5 p-5 w-full flex flex-col h-fit"
        )}
      >
        <EvaluationCard />
      </div>
    </div>
  );
};

export default DashboardHome;
